import React, { Children, cloneElement, isValidElement } from "react";
import styled from "@emotion/styled";

const Tab = ({ children, base }) => (
  <TabContainer className='nav nav-tabs nav-bold nav-tabs-line nav-tabs-line-3x' style={{ justifyContent: 'center' }}>
    {Children.map(children, (child) => {
      if (isValidElement(child)) {
        return cloneElement(child, { base })
      }
      return child
    })}
  </TabContainer>
);

const TabContainer = styled.ul`
  margin: 0px !important;
  width: 100%;
  align-self: end;
`;

export default Tab;
